const labels = {
  type: 'Tipo de informe'
}

export default {
  queue: { labels },
  recurrent: { labels }
}
